import { FC } from 'react';
import { QcReviewName } from '../../../types/QualityChecks';
import styles from './QcPreviewMode.module.css';
import QcPreviewModeOptions from '../../molecules/QcPreviewModeOptions';
import { translate } from '../../../localization';

export type QcModules = {
  status: QcReviewName;
  moduleLabel: string;
  moduleKey: string;
  needsReviewCount: number;
};
type QcPreviewModeProps = {
  modulesData: QcModules[];
  onReviewModuleClick: (moduleKey: string) => void;
};

const QcPreviewMode: FC<QcPreviewModeProps> = ({
  modulesData,
  onReviewModuleClick,
}) => {
  const handleReviewClick = (moduleKey: string) => {
    onReviewModuleClick(moduleKey);
  };
  return (
    <div className={styles['qc-preview-mode']}>
      {modulesData.map(module => {
        const { moduleKey, moduleLabel, needsReviewCount, status } = module;
        const description =
          status === QcReviewName.NEEDS_REVIEW
            ? `${translate('needs_review')} (${needsReviewCount})`
            : '';
        return (
          <QcPreviewModeOptions
            key={moduleKey}
            title={moduleLabel}
            description={description}
            status={status}
            onReviewClick={() => handleReviewClick(module.moduleKey)}
          />
        );
      })}
    </div>
  );
};

QcPreviewMode.displayName = 'QcPreviewMode';

export default QcPreviewMode;
